angular.module('zc.masterApi')

.factory "MasterProject", ($resource, $q, $stateParams, Api, Facade, projectServiceResponseTransformer, projectServiceRequestTransformer) ->
  MasterProject = $resource Api.path("/api/master/projects/:projectId"), {
    get:
      projectId: '@id'
  }, {
    query:
      method: 'GET'
      transformResponse: projectServiceResponseTransformer
      isArray: false # Rails returns object instead of array
    get:
      transformResponse: projectServiceResponseTransformer
      isArray: false # Rails returns object instead of array
    create:
      method: 'POST'
    update:
      method: 'PATCH'
      transformRequest: projectServiceRequestTransformer
      transformResponse: projectServiceResponseTransformer
    'delete':
      method: 'DELETE'
  }


  service =
    projectRanks: undefined

    create: (project) ->
      $q (resolve, reject) ->
        MasterProject.create project
        .$promise
        .then (res) ->
          resolve res.project
        , (err) ->
          reject err

    update: (params, project) ->
      d = $q.defer()
      MasterProject.update(params, project).$promise.then (res) ->
        if res.success
          d.resolve res.project
        else
          d.reject {}

      d.promise

    remove: (params) ->
      MasterProject.delete(params).$promise

    all: ->
      d = $q.defer()
      MasterProject.query().$promise.then (res) ->
        service.projects = res.projects
        d.resolve res.projects
      , (err) ->
        d.reject err
      d.promise

    addInterestTreeStatus: (projects) ->
      d = $q.defer()
      Facade.request '/master/interest_trees/statuses'
      .then (res) ->
        d.reject(projects) unless res.data.success

        statuses = res.data.statuses
        for project in projects
          project.interest_tree_status = statuses[project.apikey]
        d.resolve(projects)

      d.promise

    get: (projectId) ->
      d = $q.defer()
      MasterProject.get({projectId}).$promise.then (res) ->
        if res.project
          d.resolve res.project
        else
          # Rails returns success callback even when project is not found
          d.reject()
      , (err) ->
        d.reject err
      d.promise

    search: (options) ->
      $q (resolve, reject) ->
        Api.get "/api/master/projects/search", options
        .then (res) ->
          if !res.data.success
            reject null
          else
            resolve res.data.projects
        , (err) ->
          reject err

    getProjectRanks: (rank) ->
      $q (resolve, reject) ->
        Api.get "/api/master/projects/project_ranks", {},
          cache: true
        .then (res) ->
          service.projectRanks = res.data
          resolve service.projectRanks
        , (err) ->
          reject err

    assign: (params, user) ->
      Api.patch "/api/master/projects/#{params.projectId}/assign", user

    unassign: (params, user) ->
      Api.patch "/api/master/projects/#{params.projectId}/unassign", user

    generateProjectApikey: (site_url) ->
      $q (resolve, reject) ->
        Api.get "/api/master/projects/project_apikey?site_url=#{site_url}"
        .then (res) ->
          if !res.data.success
            reject null
          else
            resolve res.data.project_apikey
        , (err) ->
          reject err

  service



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/master_project.service.js.coffee